import { z } from 'zod';

import { stageKeySchema } from './stage.schema';

export const learningPathRecipientTypeSchema = z.enum(['TURMA', 'ALUNO']);

export const learningPathStatusSchema = z.enum(['PROGRAMADA', 'PRODUCAO', 'ENCERRADA']);

// Backend LocalDateTime format: "2026-09-25T09:00:00" (no offset, hence local)
export const backendDateTimeSchema = z.iso.datetime({ local: true });

export const createLearningPathStageSchema = z.object({
  id: stageKeySchema,
  dataDisparo: backendDateTimeSchema,
  dataEncerramento: backendDateTimeSchema,
});

export const createLearningPathPayloadSchema = z.object({
  nomTrilha: z.string(),
  escolaId: z.number().int(),
  temaId: z.number().int(),
  tipoTrilha: learningPathRecipientTypeSchema,
  entidades: z.array(z.number().int()),
  indExibePreview: z.boolean(),
  dataBloqueio: backendDateTimeSchema.nullable(),
  etapas: z.array(createLearningPathStageSchema),
});

// PUT is a partial update: the school is not editable. removerDataBloqueio clears a saved block date,
// since a null dataBloqueio means "keep the current value" on the backend.
export const updateLearningPathPayloadSchema = createLearningPathPayloadSchema.omit({ escolaId: true }).extend({
  removerDataBloqueio: z.boolean(),
});

// Backend returns the created path id wrapped in Red1000Response: { data: 123 }
export const createLearningPathResponseSchema = z.number().int();

// GET /v3/trilha-aprendizagem/:id — backend serializes with @JsonInclude(NON_NULL): null fields are omitted,
// hence nullish().
export const getLearningPathStageSchema = z.object({
  id: stageKeySchema,
  nome: z.string().nullish(),
  dataDisparo: backendDateTimeSchema.nullish(),
  dataEncerramento: backendDateTimeSchema.nullish(),
  situacao: learningPathStatusSchema.nullish(),
});

export const getLearningPathResponseSchema = z.object({
  id: z.number().int(),
  nomTrilha: z.string().nullish(),
  situacao: learningPathStatusSchema.nullish(),
  escolaId: z.number().int(),
  anoLetivo: z.number().int().nullish(),
  temaId: z.number().int().nullish(),
  tipoTrilha: learningPathRecipientTypeSchema.nullish(),
  entidades: z.array(z.number().int()).nullish(),
  indExibePreview: z.boolean().nullish(),
  dataBloqueio: backendDateTimeSchema.nullish(),
  bloqueada: z.boolean().nullish(),
  etapas: z.array(getLearningPathStageSchema).nullish(),
});

export type CreateLearningPathPayload = z.infer<typeof createLearningPathPayloadSchema>;
export type CreateLearningPathResponse = z.infer<typeof createLearningPathResponseSchema>;
export type UpdateLearningPathPayload = z.infer<typeof updateLearningPathPayloadSchema>;
export type GetLearningPathResponse = z.infer<typeof getLearningPathResponseSchema>;
export type GetLearningPathStage = z.infer<typeof getLearningPathStageSchema>;
